import { z } from 'zod';

export const stripeModes = ['test', 'live'] as const;
export const StripeModeSchema = z.enum(stripeModes);
export type StripeMode = (typeof stripeModes)[number];
